module.exports = __webpack_public_path__ + "static/media/PointOfInterest.svg";